export default "__VITE_ASSET__B$nYERgO__"